export default __webpack_public_path__ + "static/OpenSansBold-64403e4a33e046992edee2daefb2ac66.woff";